<button class="btn btn-secondary" data-testing-id="clear-basket-items" (click)="modalDialog.show()">
  {{ 'dias.shopping_cart.clear_all.button.label' | translate }}
</button>
<ish-modal-dialog #modalDialog [options]="options" (confirmed)="deleteBasket()">
  <p>{{ 'dias.shopping_cart.clear_all_dialog.content.text' | translate }}</p>
</ish-modal-dialog>
